import styled from 'styled-components';
import { breakpoints } from '../../../../shared/utils/styles';

export const Container = styled.div`
  grid-area: details;
  background-color: #eee;
  border: 1px solid gray;
  /* border-radius: 3px; */
  padding: 10px 0px;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
  font-size: min(2em, 1.9em);
  @media (max-width: ${breakpoints.auctioneer.small}) {
    font-size: min(1.2em, 1.07em);
  }
`;

export const TrackWrapper = styled.div`
  grid-row: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CenteredTrack = styled.div`
  text-align: center;
  margin: 10px 0px;
  ${(props) => props.disabled && '* {color: #aaa}'}
  & div {
    font-weight: bold;
  }
`;

export const CenterTrackHeading = styled(CenteredTrack)`
  font-size: 2em;
`;

export const Track = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 0px;
  &:last-child {
    box-sizing: border-box;
    padding: 0px;
  }
  && img:hover {
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.5);
  }
`;

export const TrackKey = styled.div`
  padding: 5px;
  margin: 3px 0px;
  width: 40%;
  text-align: right;
  font-weight: bold;
`;

export const TrackValue = styled.div`
  text-align: left;
  width: 60%;
  padding: 5px;
  margin: 3px 0px;
`;

export const HighlightContainer = styled.div`
  min-width: 100%;
  padding: 10px;
  box-sizing: border-box;
`;

export const PrivateCommentsContainer = styled(HighlightContainer)`
  background-color: #DFEBE2;
  color: #000; 
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }
  & > div:last-child {
    height: 140px;
    @media (max-width: ${breakpoints.auctioneer.small}) {
      height: 40px;
    }
    overflow-y: auto;
  }
  & i:hover {
    cursor: pointer;
  }
`;

export const PublicCommentsContainer = styled(HighlightContainer)`
  background-color: #A6B9AA;
  color: #000;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }
  & > div:last-child {
    height: 140px;
    @media (max-width: ${breakpoints.auctioneer.small}) {
      height: 40px;
    }
    overflow-y: auto;
  }
  & i:hover {
    cursor: pointer;
  }
`;
